import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails3 = () => {
  const fertilizerData = {
    title: "Utpann Plant Booster",
    category: "Liquid Fermented Organic Manure (FOM)",
    image: "/assets/Product/img3.png", // Aap apni file path yahan daal sakte hain
    description:
      "UTPANN Plant Booster is a fast-acting organic growth enhancer that strengthens plants from root to tip. It boosts nutrient absorption, promotes vigorous growth, and improves flowering and fruiting. Safe and eco-friendly, Plant Booster helps farmers achieve healthier crops and higher yields naturally.",
    price: "1399",
    priceNote: "Per 20 ltr Drum (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Soil Carbon Enhancement", "Forestry"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      { label: "Moisture% by weight maximum", value: "90–97%" },
      { label: "Total Organic Carbon minimum", value: "1.5%" },
      { label: "pH", value: "6.0–8.4" },
      { label: "Electrical Conductivity", value: "Not more than 4.0" },
      { label: "Pathogens", value: "Nil" },
    ],
    packaging: [
      { label: "Bulk Bags", value: "1000ltr IBC" },
      { label: "Standard Drum", value: "10ltr / 20ltr / 50ltr" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Accelerates overall plant growth and vitality",
      "Enhances nutrient uptake and root development",
      "Improves flowering, fruit set, and crop yield",
      "Strengthens plant resistance to stress and diseases",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={fertilizerData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails3;
